import React, { useContext } from 'react';
import { DateTime } from 'luxon';

import { media } from 'context';
import { Layout, Text } from 'ds';
import {
  selectOnboardingServiceStartDate,
  selectOnboardingStandardDay,
  selectOnboardingTouchUpDay
} from 'store/CleaningService/selectors';
import { useAppSelector } from 'store/hooks';

import CleaningServiceMonthBreakdownEstimate from './CleaningServiceMonthBreakdownEstimate';
import { calculateCleaningSchedule } from './utils';

interface Props {}

const CleaningServiceCheckoutServiceBreakdown: React.FC<Props> = () => {
  const { isMobile } = useContext(media);
  const cleaningServiceStartDate = useAppSelector(selectOnboardingServiceStartDate);
  const standardDay = useAppSelector(selectOnboardingStandardDay);
  const touchUpDay = useAppSelector(selectOnboardingTouchUpDay);

  if (!cleaningServiceStartDate || !standardDay) {
    return null;
  }
  const cleaningSchedule = calculateCleaningSchedule(
    DateTime.fromISO(cleaningServiceStartDate),
    standardDay,
    touchUpDay
  );
  return (
    <Layout direction="column" gap={24} paddingX={isMobile ? 24 : undefined} paddingY={isMobile ? 24 : undefined}>
      <Layout direction="column" gap={8}>
        <Text size="headline-sm">Service breakdown</Text>
        <Text size="body-sm" color="gray-700">
          Below is the{' '}
          <span style={{ fontWeight: 600, fontSize: 14, lineHeight: '20px', letterSpacing: '0.02em' }}>
            projected cost
          </span>{' '}
          for the next 3 months based on your current selection. Your monthly charges vary based on the number of weekly
          cleanings and touch-ups scheduled each month.
        </Text>
      </Layout>
      {cleaningSchedule.map(monthSchedule => (
        <CleaningServiceMonthBreakdownEstimate key={monthSchedule.month} monthSchedule={monthSchedule} />
      ))}
    </Layout>
  );
};

export default CleaningServiceCheckoutServiceBreakdown;
